<div class="efx-row-datasource source_item" style="display: flex;flex-direction: column;padding-bottom:15px;">
  <!-- title section -->
  <div class="section_info d-flex justify-content-between">
    <div class="efx-row-title item_title">
      Situaciones
      <div class="w-123"></div>
    </div>
    <div class="historicalNav" style="display: flex; justify-content: end; padding: 0px 20px;">
      <!-- VIEW MODE / CREATE MODE -->
      @if (!isEditing) {
        <ng-container style="display: flex; justify-content: end; padding: 0px 20px;">
          @if (isCreating) {
            <div class="prev">
              <em class="fa fa-angle-double-left" style="font-size:20px;color: gray; cursor: default"></em>
            </div>
            <div class="next" style="margin-left: 30px;">
              <em class="fa fa-angle-double-right" style="font-size:20px;color: gray; cursor: default"></em>
            </div>
          }
          @if (!isCreating) {
            <div class="prev" (click)="prevHistorical()">
              <em class="fa fa-angle-double-left" style="font-size:20px;cursor: pointer;"></em>
            </div>
            <div class="next" style="margin-left: 30px;" (click)="nextHistorical()">
              <em class="fa fa-angle-double-right" style="font-size:20px;cursor: pointer;"></em>
            </div>
          }
        </ng-container>
      }
      <!-- EDIT MODE -->
      @if (isEditing) {
        @if (typeSituacion === 'situation') {
          <div class="all me-3" matTooltip="Rellenar todo los periodos" (click)="updateAllPeriod()">
            <em class="fas fa-asterisk" style="font-size:20px;cursor: pointer;"></em>
          </div>
        }
        <div class="prev">
          <em class="fa fa-angle-double-left" style="font-size:20px;color: gray; cursor: default"></em>
        </div>
        <div class="next" style="margin-left: 30px;">
          <em class="fa fa-angle-double-right" style="font-size:20px;color: gray; cursor: default"></em>
        </div>
      }
    </div>
  </div>

  <!-- historical section -->
  <div class="history_items d-flex" [ngClass]="{'justify-content-start':typeSituacion === 'situation'}" >
    <div>
      <div class="col efx-row-input-title" style="padding: 5px 0px;display: flex;flex-direction: column; align-items: start;min-width: 20px;">
        <div style="height:20px; display: flex;align-items: center;">Año</div>
        <div style="height:30px; display: flex;align-items: center;">Mes</div>
        <div style="height:30px; display: flex;align-items: center; margin-top: 5px;">
          @if (typeSituacion === 'situation') {
            <ng-containe>
              <div class="wrapper_item_value">Situación</div>
            </ng-containe>
          } @else {
            <div class="wrapper_item_value">Día</div>
          }
        </div>
      </div>
    </div>
    @if (typeSituacion === 'situation') {
      <ng-containe class="d-flex">
        @for (item of this.arrayPeriodosHist | paghistorico:page; track item; let i = $index) {
          <div class="ms-4">
            <div class="col efx-row-input-title" (click)="selectPeriods(item)"
              style="padding: 5px 0px;display: flex;flex-direction: column; align-items: center;min-width: 20px;">
              <div
                class="item_year py-2 rounded"
                style="height:20px; display: flex;align-items: center; cursor: pointer"
                [ngClass]="{'text-white':item.active && item.editable === 'N'}">
                {{item.anio}}
              </div>
              <div class="item_month rounded" style="height:30px; display: flex;align-items: center; cursor: pointer"
                #identificadorAcumula id="month_{{item.periodo}}">
                {{item.mesnum}}
              </div>
              @if (!isEditing) {
                <div
                  class="item_value"
                  style="height:30px; display: flex;align-items: center; margin-top: 5px; cursor: pointer"
                  >
                  <div class="wrapper_item_value p-2 rounded" [ngClass]="{'text-white':item.active && item.editable === 'S'}">
                    {{item.situacion_new}}
                  </div>
                </div>
              }
              @if (isEditing && item.editable === 'S') {
                <div class="edit_history_item">
                  <input type="text rounded"
                    #identificador
                    style="text-align: center;width: 25px;"
                    [id]="item.periodo"
                    [value]="item.situacion"
                    maxlength="1"
                    name="{{item.anio}}{{item.mesnum}}"
                    (input)="onChangeSituacion($event)"
                    (blur)="checkNextSituacion($event)"
                    (click)="changeToPediod(item.periodo)"
                    class="nav_situacion_item"
                    >
                  </div>
                }
              </div>
            </div>
          }
        </ng-containe>
      } @else {
        @for (item of this.arrayPeriodosHist | paghistorico:page; track item; let i = $index; let firs = $first; let last = $last) {
          <div class="" [ngClass]="{'ms-5':firs}">
            <div class="d-flex efx-row-input-title" (click)="selectPeriods(item)"
              style="padding: 5px 0px;display: flex;flex-direction: column; align-items: center;min-width: 20px;"
              [ngClass]="{'mx-3':firs,'mx-2':!firs}"
              >
              <div class="item_year" style="height:20px; display: flex;align-items: center; cursor: pointer">{{item.year}}
              </div>
              <div class="item_month rounded" style="height:30px; display: flex;align-items: center; cursor: pointer">
                {{item.month}}
              </div>
              <div class="item_value"
                style="height:30px; display: flex;align-items: center; margin-top: 5px; cursor: pointer">
                <div class="wrapper_item_value p-2 text-white rounded" [ngClass]="{'text-white':item.active}">
                  {{item.day}}
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
